import { https } from "../http";
import store from "../store";
import {
  setAddMarLoading,
  setCalendarEntries,
  setLoading,
  setMar,
  setMedicationLogs,
  setNewMarLogs,
  setSelectedClient,
} from "../store/reducers/mar";

import { showError } from "../utils/index";
import { getAllPatientsModal, getSinglePatients } from "./patient";

// Simple in-memory cache: key = "clientId_page", value = response data.
// Cleared whenever a mutation (create/update/delete) happens so stale data
// is never shown after a change. TTL prevents serving data that is hours old.
const marCache = new Map();
const MAR_CACHE_TTL_MS = 5 * 60 * 1000; // 5 minutes

export const clearMarCache = () => {
  marCache.clear();
  store.dispatch(setCalendarEntries([]));
};

// for single mar to be added

const createMar = async (data, callback) => {
  try {
    store.dispatch(setAddMarLoading(true));
    let response = await https().post("/mar/create", data);
    if (response) {
      clearMarCache();
      //getNotes(false);
      // getAllPatientsModal("all", true, data?.client)
      getSinglePatients(data?.client);
      callback?.();
      return true;
    }
  } catch (error) {
    let _error = error?.response?.data?.message;
    if (_error?.includes("duplicate") && _error?.includes("name"))
      showError("This name is already taken");
    else showError(_error, error?.response?.status);
    store.dispatch(setAddMarLoading(false));
    // showError(error?.response?.data?.message, error?.response?.status)
    return false;
  }
};

const recordResponse = async (data, callback) => {
  try {
    store.dispatch(setAddMarLoading(true));
    let response = await https().post("/mar/updatePrnFeedback", data);

    if (response?.status === 200) {
      clearMarCache();
      callback?.();
      getMar();
    }
  } catch (error) {
    let _error = error?.response?.data?.message;
    showError(_error, error?.response?.status);
    // showError(error?.response?.data?.message, error?.response?.status)
    return false;
  }
};

const updateMar = async (data, callback) => {
  try {
    store.dispatch(setAddMarLoading(true));
    let response = await https().post("/mar/update", data);

    if (response?.status === 200) {
      store.dispatch(setAddMarLoading(false));
      callback?.();
    }
  } catch (error) {
    let _error = error?.response?.data?.message;
    if (_error?.includes("duplicate") && _error?.includes("name"))
      showError("This name is already taken");
    else showError(_error, error?.response?.status);
    store.dispatch(setAddMarLoading(false));
    // showError(error?.response?.data?.message, error?.response?.status)
    return false;
  }
};

//get

const getMar = async (
  page = localStorage.getItem("calendar_date"),
  Userid,
  // businessTimezone,
  showLoading = true,
  dates,
  logType,
  logSearch,
  hideDiscontinued,
) => {
  const selectedClient = store?.getState()?.mar?.selectedClient?.id;
  const clientId = Userid || selectedClient;
  const cacheKey = `${clientId}_${page}`;
  const cached = marCache.get(cacheKey);

  // Serve from cache if fresh — avoids a full round-trip when switching tabs
  if (cached && Date.now() - cached.ts < MAR_CACHE_TTL_MS) {
    store.dispatch(setMar(cached.data));
    return;
  }

  try {
    if (showLoading) store.dispatch(setLoading(true));

    let response = await https().get(
      `/mar/get?client=${clientId}&page=${page}&filterDateStart=${dates?.[0]}&filterDateEnd=${
        dates?.[1]
      }&filterType=${logType}&logSearch=${logSearch}${
        typeof hideDiscontinued === "boolean"
          ? `&hideDiscontinued=${hideDiscontinued}`
          : ""
      }`,
    );

    if (response?.status === 200) {
      let save = response?.data?.data;
      marCache.set(cacheKey, { data: save, ts: Date.now() });
      store.dispatch(setMar(save));
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  } finally {
    store.dispatch(setLoading(false));
  }
};
const getCalendarViewData = async (
  page = localStorage.getItem("calendar_date"),
  Userid,
  showLoading = true,
  hideDiscontinued,
) => {
  const selectedClient = store?.getState()?.mar?.selectedClient?.id;
  const clientId = Userid || selectedClient;
  const cacheKey = `cv_${clientId}_${page}`;
  const cached = marCache.get(cacheKey);

  if (cached && Date.now() - cached.ts < MAR_CACHE_TTL_MS) {
    store.dispatch(setCalendarEntries(cached.data));
    return;
  }

  try {
    if (showLoading) store.dispatch(setLoading(true));

    const qs = [
      `client=${clientId}`,
      `page=${page}`,
      typeof hideDiscontinued === "boolean"
        ? `hideDiscontinued=${hideDiscontinued}`
        : null,
    ]
      .filter(Boolean)
      .join("&");

    const response = await https().get(`/mar/getCalendarView?${qs}`);

    if (response?.status === 200) {
      const entries = response?.data?.data?.entries ?? [];
      marCache.set(cacheKey, { data: entries, ts: Date.now() });
      store.dispatch(setCalendarEntries(entries));
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  } finally {
    store.dispatch(setLoading(false));
  }
};

const getMarLogsNew = async (
  page,
  Userid,
  showLoading = true,
  logSearch,
  filterDates = [null, null],
) => {
  try {
    const selectedClient = store?.getState()?.mar?.selectedClient?.id;

    // Use setAddMarLoading (not setLoading) so the log-tab loading indicator
    // is independent from the main MAR calendar loading flag.  Sharing setLoading
    // caused the calendar to flicker/lock when the log tab was clicked while MAR
    // data was still loading, and the log tab appeared broken (never opened).
    if (showLoading) store.dispatch(setAddMarLoading(true));
    const startDate = filterDates?.[0] ?? null;
    const endDate = filterDates?.[1] ?? null;
    let response = await https().get(
      `/mar/getMarLogsNew?client=${
        Userid ? Userid : selectedClient
      }&page=${page}&logSearch=${logSearch !== "" ? logSearch : "undefined"}&filterDateStart=${startDate}&filterDateEnd=${endDate}`,
    );

    if (response?.status === 200) {
      store.dispatch(setNewMarLogs(response?.data?.data));
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  } finally {
    store.dispatch(setAddMarLoading(false));
  }
};

const getMedicationLogs = async (
  page,
  Userid,
  showLoading = true,
  logSearch,
) => {
  const selectedClient = store?.getState()?.mar?.selectedClient?.id;
  try {
    store.dispatch(
      setMedicationLogs({
        newMar: [],
        count: 0,
      }),
    );
    // Use setAddMarLoading (not setLoading) to keep the log-tab loading state
    // independent from the main MAR calendar loading flag.
    if (showLoading) store.dispatch(setAddMarLoading(true));
    let response = await https().get(
      `/mar/getMedicationLogs?client=${
        Userid ? Userid : selectedClient
      }&page=${page}&logSearch=${logSearch !== "" ? logSearch : "undefined"}`,
    );

    if (response?.status === 200) {
      let save = response?.data?.data;
      store.dispatch(setMedicationLogs(save));
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  } finally {
    store.dispatch(setAddMarLoading(false));
  }
};

const getAddedTimeSlots = async (payload) => {
  try {
    let response = await https().get(
      `/mar/getClientTimeSlots?client=${payload.client}&medicationId=${payload.medicationId}`,
    );

    if (response?.status === 200) {
      return response?.data;
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

export const deleteMar = async (payload) => {
  try {
    let response = await https().post(`/mar/delete`, payload);

    if (response?.status === 200) {
      clearMarCache();
      // Refresh BOTH the patient (form3 medicine counts) AND the MAR appointments
      // array.  Without getMar(), the Redux appointments array stays stale after a
      // reset — the pill keeps its old color, clicking it re-opens the old status
      // view instead of the correct "upcoming / Missed" form.
      getSinglePatients(payload?.client);
      getMar(localStorage.getItem("calendar_date"), payload?.client, false);
      return response?.data;
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  }
};
export const deleteNewMarLog = async (payload) => {
  try {
    let response = await https().post(`/mar/deleteNewMarLog`, payload);

    if (response?.status === 200) {
      //  getMar(localStorage.getItem("calendar_date"), null, false);
      getSinglePatients(payload?.client);
      // getMar("all");
      return response?.data;
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

export const updateMedicationAdministration = async (payload) => {
  try {
    let response = await https().post(`/mar/update-administered-mar`, payload);
    if (response) {
      clearMarCache();
      return response;
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

export const updateMarStatus = async (payload) => {
  try {
    let response = await https().post(`/mar/update-status`, payload);
    if (response) {
      clearMarCache();
      return response;
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

export const updateDiscontinue = async (payload, clientId) => {
  try {
    let response = await https().post(`/client/discontinuemedication`, payload);
    if (response) {
      clearMarCache();
      await getAllPatientsModal("all", true, clientId);
      getMar(localStorage.getItem("calendar_date"), clientId, false);
      return response;
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

export const updateFillMedication = async (payload) => {
  try {
    let response = await https().post(`/client/updateMedicineCount`, payload);
    if (response) {
      clearMarCache();

      // Fetch authoritative data first, then re-apply refill fields.
      // getSinglePatients overwrites Redux with backend data — if the backend
      // doesn't persist lastRefillDate/lastRefillBy on the medication record,
      // the patch below ensures the column stays populated for this session.
      await getSinglePatients(payload?.clientId);
      getMar(localStorage.getItem("calendar_date"), payload?.clientId, false);

      const currentClient = store.getState().mar.selectedClient;
      if (currentClient?.form3 && payload.medicationId) {
        const patched = currentClient.form3.map((med) =>
          String(med.id) === String(payload.medicationId)
            ? {
                ...med,
                lastRefillDate: payload.refillDate,
                lastRefillBy: payload.refillBy,
              }
            : med,
        );
        const patchedClient = { ...currentClient, form3: patched };
        localStorage.setItem("selectedClient", JSON.stringify(patchedClient));
        store.dispatch(setSelectedClient(patchedClient));
      }

      return response;
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

export {
  createMar,
  getMar,
  getCalendarViewData,
  getMarLogsNew,
  getAddedTimeSlots,
  updateMar,
  recordResponse,
  getMedicationLogs,
};
